// extracted by mini-css-extract-plugin
export default {"foods":"Foods_foods__b8bxm","container":"Foods_container__vKHEP","food":"Foods_food__e-acI","menu":"Foods_menu__d3hwP","menuContainer":"Foods_menuContainer__HB5ew"};